/**
 * Marquee Alpine Component
 * Handles smooth scrolling text animation with pause on hover
 */
export default function marquee() {
  return {
    paused: false,

    init() {
      // Component initializes with paused = false
      // Text will scroll by default
    },
  };
}
